import React, { useEffect, useState } from "react";
import find from "lodash/find";
import ReactDatePicker from "react-datepicker";
import { User, Calendar, X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import moment from "moment";
import api from "../../../utils/api";
import close_modal from "./../../../assets/ic_close_modal.svg";
import MultiSelectAll from "../../../common/Multiselect/MultiSelectAll";
import Select from "react-select";

export default function ToolsTemplateFilterModal(props) {

    return (
      <Modal 
        isOpen={props.isOpen}
        onRequestClose={props.toggleModal}
        ariaHideApp={false}
      >
        <ModalContent className="lpmss-filters-modals ">
            <div className="modal-header-sp">
            <span className="modal-title">Filter By</span>
              <img
                  alt="close"
                  id="Close"
                  src={close_modal}
                  className="close modal-close"
                  onClick={props.toggleModal}
              />
            </div>
          
          <div
              className={`modal-body spled-container notes-trail-content custom-scrollbar conv-pl0 conv-pr0`}
          >
              <div className="row conv-mt5">
                   
                   
              </div>
              <div className="row conv-mt20">
                  <div className="col-12 width-100">
                      <MultiSelectAll
                           toggleAll={props.toggleAllForServiceStatusFilter}
                           toggleSelection={props.toggleSelectionForServiceStatusFilter}
                           checkboxItemsList={props.serviceStatusNameListForFilter1}
                           selectedOptions={props.selectedServiceStatusListForFilter1}
                           placeholderButtonLabel={"Select Tool"}
                      />
                       
                  </div>
              </div>
              <div className="row conv-mt20">

              <div className="col-12 width-100">
                        <MultiSelectAll
                          toggleAll={props.toggleAllForPackageFilter}
                          toggleSelection={props.toggleSelectionForPackageFilter}
                          checkboxItemsList={props.packageNameListForFilter}
                          selectedOptions={props.selectedPackageNameListForFilter}
                          placeholderButtonLabel={"Select Template"}
                        />
              </div>
              </div>
              
              <div className="row conv-mt30 ">
                  <div className="col-12 lpmss-modal-bottom-action bottom-action ">
                     
  
                      <button 
                          type="button" 
                          className="lpm-con-btn-bordered-filter conv-pr25 conv-mr-10 conv-pl25 "
                          onClick={(e) =>props.onClearFilterSearch(e)}>
                          Clear All
                      </button>
                      <button 
                          type="button" 
                          className="lpm-con-btn-filled conv-pr35 conv-float-right conv-pl35 conv-ml-20"
                          onClick={(e) =>props.onSearchClicked(e)}>
                          Apply
                      </button>
                  </div>
              </div>
          </div>
        </ModalContent>
      </Modal>
    );
  }